import {
	fa1 as fas1,
	fa2 as fas2,
	fa3 as fas3,
	faCalculator as fasCalculator,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { LoanInsuranceSmallCalculator } from "@component/LoanInsurance/SmallCalculator/LoanInsuranceSmallCalculator";
import { MAX_BABY_LOAN_AMOUNT, MAX_PERSONAL_LOAN_AMOUNT } from "@component/LoanInsurance/SmallCalculator/data";
import { Ad } from "@component/Widget/Ad/Ad";
import { YoutubeVideo } from "@component/Widget/YoutubeVideo/YoutubeVideo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import biztonsag1 from "@img/landing/biztositas/biztonsag/biztonsag_01.jpg";
import biztonsag2 from "@img/landing/biztositas/biztonsag/biztonsag_02.jpg";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { LandingBottom } from "@landing/components/LandingBottom";
import { LandingHeader } from "@landing/components/LandingHeader";
import { LandingHeaderLayout } from "@landing/components/LandingHeaderLayout";
import { faBankmonitor } from "@ui/fortawesome/bankmonitor";
import { BmBadge, Button, LandingContainer, List, ListUi3, ListUi3Item, Stack, TimeLine, Typography } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Accordion, Badge, Card, Col, Row } from "react-bootstrap";
import { PREMIUM_PRODUCTS } from "./bankmonitor-biztonsag.data";
import "./bankmonitor-biztonsag.scss";

const H2_CLASSES = "h1 mb-lg-4 mb-md-3 mb-2";

/**
 * @Routing
 *
 * @title "Bankmonitor Biztonság / Csoportos személybiztosítás"
 * @description "Csoportos személybiztosítás, ami lakáshitel, babaváró és személyi hitel mellé nyújt komplex megoldást baj esetén."
 * @route "/vedelem/bankmonitor-biztonsag/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<LandingHeader theme="retail" id="calculator-container">
					<LandingHeaderLayout template="small-calculator">
						<Stack
							gap={{
								xs: 4,
								lg: 4,
							}}
							alignItems={"start"}
						>
							<div>
								<Typography as="h1" variant="title-1" gutterBottom>
									Bankmonitor biztonság
								</Typography>
								<Typography as="h1" variant="subtitle-1">
									Amit az igényeitek teremtettek!
								</Typography>
							</div>
							<BmBadge prepend={<FontAwesomeIcon icon={faBankmonitor} />} className="my-1">
								Kizárólag a bankmonitornál!
							</BmBadge>
							<span className="font-weight-bold">
								Létrehoztuk neked azt az online biztosítást, ami lakáshitel, Babaváró és személyi hitel
								mellé nyújt komplex megoldást baj esetén.
							</span>
							<ListUi3 gutterSize="sm">
								<ListUi3Item>Hitelfelvételt követően utólag is megköthető </ListUi3Item>
								<ListUi3Item>
									Akár 6 hónapig fizet tartós táppénz, vagy munkanélküliség esetén
								</ListUi3Item>
								<ListUi3Item>Közös megegyezéssel megszűnt munkaviszony esetén is</ListUi3Item>
								<ListUi3Item>
									Te, vagy a családod kapja meg a biztosítási összeget a bank helyett
								</ListUi3Item>
								<ListUi3Item>
									Piaci átlag feletti, jelzáloghitelnél akár 80 millió forintos hitelösszegre
								</ListUi3Item>
								<ListUi3Item>Teljesen online folyamat</ListUi3Item>
								<ListUi3Item>Orvosi vizsgálat nélkül</ListUi3Item>
							</ListUi3>
						</Stack>
						<span id="calc-desk" className="d-none d-lg-inline-block">
							<LoanInsuranceSmallCalculator variant="NN" />
						</span>
					</LandingHeaderLayout>
				</LandingHeader>
				<LandingContainer size="lg">
					<Row>
						<Col md={6}>
							<h2 className={H2_CLASSES}>Neked ajánljuk a Bankmonitor Biztonság biztosítást:</h2>
							<List itemStyle="tick" variant="secondary" size="lg">
								<List.Item>
									Ha{" "}
									<a
										href="/babavaro-hitel/?link_type=landing-link"
										// biome-ignore lint/a11y/noBlankTarget: in-page link
										target="_blank"
										rel="noreferrer"
									>
										Babaváró hitelt
									</a>
									,{" "}
									<a
										href="/lakashitel-kalkulator/?link_type=landing-link"
										// biome-ignore lint/a11y/noBlankTarget: in-page link
										target="_blank"
										rel="noreferrer"
									>
										lakáshitelt
									</a>
									, vagy{" "}
									<a
										href="/szemelyi-kolcson/?link_type=landing-link"
										// biome-ignore lint/a11y/noBlankTarget: in-page link
										target="_blank"
										rel="noreferrer"
									>
										személyi kölcsönt
									</a>{" "}
									tervezel felvenni a Bankmonitornál és fontos számodra a magad és családod anyagi
									biztonsága,
								</List.Item>
								<List.Item>
									vagy rendelkezel már ilyen hitelekkel, és a jelenlegi gazdasági környezetben úgy
									érzed nagyobb biztonságra lenne szükséged.
								</List.Item>
								<List.Item>De akkor is ha a meglévő biztosításod cserélnéd egy kedvezőbbre.</List.Item>
							</List>
						</Col>
						<Col md={6}>
							<img src={biztonsag1} alt="Biztonság biztosítás" />
						</Col>
					</Row>
				</LandingContainer>
				<span className="d-block d-md-none">{this.renderCta()}</span>
				<LandingContainer size="lg" bgClassName="bg-gray">
					<Row className="justify-content-center">
						<Col lg={10}>
							<h2 className="h1 mb-4 text-center">Melyik biztosítási csomagot válasszam?</h2>
							{this.renderHeaderSlider()}
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer size="lg">
					<Row>
						<Col lg={6}>
							<h2 className={H2_CLASSES}>Mi a szerződéskötés folyamata? </h2>
							<TimeLine size="sm">
								<TimeLine.Item
									title={<strong>Kalkuláció</strong>}
									fill
									icon={<FontAwesomeIcon icon={fas1} />}
								>
									Nézd meg nagyságrendileg mennyibe kerülne számodra a biztosítás.
								</TimeLine.Item>
								<TimeLine.Item
									title={<strong>Kapcsolatfelvétel</strong>}
									fill
									icon={<FontAwesomeIcon icon={fas2} />}
								>
									Telefonos egyeztetés szakértőnkkel, hogy megtaláld a számodra legkedvezőbb
									megoldást.
								</TimeLine.Item>
								<TimeLine.Item
									title={<strong>Online szerződéskötés</strong>}
									fill
									icon={<FontAwesomeIcon icon={fas3} />}
								>
									Zárt, biztonságos rendszeren keresztül, teljesen online, néhány perc alatt.{" "}
								</TimeLine.Item>
							</TimeLine>
						</Col>
						<Col className="text-center" lg={6}>
							<img className="mt-3" src={biztonsag2} alt="Biztonság biztosítás" />
						</Col>
					</Row>
				</LandingContainer>
				{this.renderCta()}
				<LandingContainer size="lg">
					<Row className="justify-content-center">
						<Col lg={10}>
							<h2 className={`${H2_CLASSES} text-center`}>
								Általános tudnivalók a hitelfedezeti biztosításról
							</h2>
							{this.renderFaq()}
							<Ad
								name="300x250 MOBIL TOP2"
								code="5967599"
								width="300"
								height="250"
								type="non-desktop"
								priority={46}
							/>
						</Col>
					</Row>
				</LandingContainer>
				{this.renderCta()}
				{this.renderVideos()}
				<LandingBottom tags="biztositas" />
			</>
		);
	}

	private renderCta(): ReactNode {
		return (
			<LandingContainer bgClassName="bg-trianglify-purple bg-border-y text-center" bgColor="#c33350">
				<div className="h3 text-white">Kalkulálj és tudd meg mennyibe kerül anyagi biztonságod</div>
				<Button
					variant="secondary"
					size="lg"
					className="d-none d-xl-inline-block mt-3"
					icon={<FontAwesomeIcon icon={fasCalculator} />}
					href="#calc-desk"
				>
					Biztosítás kalkulátor
				</Button>
				<Button
					variant="secondary"
					size="lg"
					className="d-xl-none mt-3"
					icon={<FontAwesomeIcon icon={fasCalculator} />}
					href="#calc-mob"
				>
					Biztosítás kalkulátor
				</Button>
			</LandingContainer>
		);
	}

	private renderFaq(): ReactNode {
		return (
			<>
				<Accordion>
					<LandingAccordion title="Mi az a hitelfedezeti biztosítás?">
						<p>
							A hitelfedezeti biztosítás egy olyan életbiztosítás, amely egy hitel visszafizetését
							garantálja a biztosított halála, vagy meghatározott fokú rokkantsága esetén.
						</p>
						<p>Két fajtája van:</p>
						<ol>
							<li>
								Az egyik esetben csak a fennálló tartozást fizeti ki a Biztosító a bank felé. Ez azt is
								jelenti, hogy a biztosítás összege folyamatosan csökken, hiszen a fennálló tartozás is
								egyre kisebb a futamidő előrehaladtával. Ez jellemzően alacsonyabb biztosítási díj
								mellett köthető.
							</li>
							<li>
								A másik esetben egy meghatározott összegre kötik meg a biztosítást, ami jellemzően az
								igényelt hitelösszeggel egyezik meg. Ennek a konstrukciónak valamelyest magasabb a díja,
								cserébe egy káresemény bekövetkeztekor a család is kap egy meghatározott összeget: az
								aktuálisan fennálló tartozás és a biztosítási összeg különbözete jár a család részére.
							</li>
						</ol>
						<p>
							A Bankmonitor Biztonság Csoportos Személybiztosítás Élet csomagja és a Bankmonitor Biztonság
							Csoportos Személybiztosítás Komplex csomagja ez utóbbi kategóriába sorolható, vagyis
							mindenképpen az induló biztosítási összeg kerül kifizetésre a korábban említett események
							bekövetkeztekor.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Csak halál, rokkantság esetén fizet egy törlesztésvédelmi biztosítás?">
						<p>
							Nem feltétlenül, vannak olyan biztosítások, melyeknél meghatározott esemény – betegség,
							munkanélküliség – bekövetkeztekor a biztosító átmenetileg megfizeti helyettünk a
							törlesztőrészletet.
						</p>
						<p>
							Az egyes biztosítási csomagok esetében a feltételek eltérőek, érdemes előzetesen
							tájékozódni. A Bankmonitor Biztonság Biztosítás esetében mindkét kiegészítő szolgáltatás
							megtalálható a megfelelő csomag kiválasztásakor.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mikor érdemes biztosítást kötni?">
						<p>
							Hitelfedezeti biztosítást jellemzően a kölcsön igénylésekor kötünk. Ez érthető is, hiszen a
							kölcsönfelvételből eredő kockázatokat szeretnénk csökkenteni.
						</p>
						<p>
							Ettől függetlenül a legtöbb hitelfedezeti biztosítást a futamidő alatt is igénybe vehetjük.
							Jellemzően valamilyen rendkívüli életesemény – például a gyermekünk születése – döbbent rá a
							biztonság fontosságára.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Hogyan lehet rendezni a biztosítási díjat?">
						<p>
							A legtöbb esetben megválaszthatjuk a díjfizetés gyakoriságát. A Bankmonitor Biztonság
							Csoportos Személybiztosítás esetében havi, negyedéves, féléves és éves díjfizetést is
							választhatunk.
						</p>
						<p>
							A díjat jellemzően kártyás befizetéssel és átutalással is lehet rendezni a Biztosító felé. A
							Bankmonitor Biztonság Csoportos Személybiztosítás esetében is van mindkét fizetési módra
							lehetőség. Sőt, a Bankmonitor Ügyfélportál felületén keresztül nyomon követhetjük a
							díjfizetés aktuális helyzetét.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mekkora hitelösszegre nyújt védelmet a Bankmonitor Biztonság biztosítás?">
						<p>
							Lakáshitel esetében a hitelösszeg legfeljebb 80 millió forint lehet. Ráadásul ilyen magas
							összeg esetében sem kér a biztosító egyedi orvosi vizsgálatot, elégséges az egészségügyi
							nyilatkozat kitöltése. Ez kiemelkedő, hiszen a piacon elérhető más biztosítások esetében
							egyedi orvosi vizsgálat nélkül a maximális kölcsönösszeg jellemzően ennél jóval kisebb
							lehet.
						</p>
						<p>
							Babaváró hitel esetén {MAX_BABY_LOAN_AMOUNT / 1_000_000} millió Ft, míg személyi kölcsön
							esetében {MAX_PERSONAL_LOAN_AMOUNT / 1_000_000} millió Ft a maximális biztosítási összeg.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Milyen kölcsönök esetében igényelhető hitelfedezeti biztosítás?">
						<p>
							Személyi kölcsön, jelzáloghitel és Babaváró hitel is kapcsolható a Bankmonitor Biztonság
							Biztosításhoz. Egy biztosítási szerződés csak egy hiteltípushoz köthető, amelyet a
							szerződéskötéskor kell kiválasztanunk.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Több hitelre is érvényes lehet egy biztosítási szerződés?">
						<p>
							Alapvetően nem, egy biztosítás csak egy hitelszerződésre nyújt védelmet. Előfordulhat
							azonban, hogy ugyanazon lakáscélunkat több hitelből finanszíroztuk meg. (Például a piaci
							lakáshitel mellé támogatott jelzáloghitelt is igényeltünk.) Ebben az esetben a két kölcsönre
							együttesen kiterjed a biztosítási védelem.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Miért van három biztosítási csomag?">
						<p>
							A Bankmonitor Biztonság Csoportos Személybiztosítás három csomagja különböző
							szolgáltatásokat nyújt, vagyis különböző káresemények esetére kaphatunk védelmet. A többféle
							csomagból a hitellel rendelkezők széles köre találhatja meg a számára kedvező megoldást.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mi ellen nyújt védelmet a Bankmonitor Biztonság Komplex csomagja?">
						<p>
							Halál, vagy 70 százalékot elérő rokkantság esetén kifizetik a biztosítási összeget. A
							családunk megkapja a kezdeti hitelösszeggel egyenlő biztosítási összeget, amelyből a
							fennálló tartozás kifizethető a bank felé és a fennmaradó részből átvészelhető a kezdeti
							nehéz időszak.
						</p>
						<p>
							Emellett 30 napot meghaladó táppénz esetén a betegség ideje alatt, de legfeljebb hat hónapon
							keresztül kifizeti a biztosító helyettünk a törlesztőrészletet. A biztosítás futamideje
							alatt többször is igénybe vehetjük ezt a szolgáltatást, de összességében legfeljebb 18 hónap
							törlesztőrészletét fizeti meg a biztosító helyettünk.
						</p>
						<p>
							Ha elveszítjük munkahelyünket, akkor a 31. naptól legfeljebb 6 hónapon keresztül a biztosító
							kifizeti a törlesztőrészletet felénk, így tudjuk rendezni a kölcsön részleteit. A futamidő
							alatt többször is igénybe vehetjük ezt a szolgáltatást, de összességében legfeljebb 18 hónap
							törlesztőrészletét fizeti meg a biztosító helyettünk.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mi ellen nyújt védelmet a Bankmonitor Biztonság Élet csomagja?">
						<p>
							Halál, vagy 70 százalékot elérő rokkantság esetén kifizetik a biztosítási összeget. A
							családunk a kezdeti hitelösszeggel egyenlő biztosítási összeget megkapja, amelyből a
							fennálló tartozás kifizethető a bank felé és a fennmaradó részből átvészelhető a kezdeti
							nehéz időszak.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mi ellen nyújt védelmet a Bankmonitor Biztonság Jövedelem csomagja?">
						<p>
							30 napot meghaladó táppénz esetén a betegség ideje alatt, de legfeljebb hat hónapon
							keresztül kifizeti a biztosító helyettünk a törlesztőrészletet. A biztosítás futamideje
							alatt többször is igénybe vehetjük ezt a szolgáltatást, de összességében legfeljebb 18 hónap
							törlesztőrészletét fizeti meg a biztosító helyettünk.
						</p>
						<p>
							Emellett, ha elveszítjük munkahelyünket, akkor a 31. naptól legfeljebb 6 hónapon keresztül a
							biztosító kifizeti a törlesztőrészletet felénk, így tudjuk rendezni a kölcsön részleteit. A
							futamidő alatt többször is igénybe vehetjük ezt a szolgáltatást, de összességében legfeljebb
							18 hónap törlesztőrészletét fizeti meg a biztosító helyettünk.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Több személy is lehet biztosított?">
						<p>
							Igen, a hitelügyletben szereplő két adósra, adóstársra lehet megkötni a biztosítást. Ha a
							két szereplő bármelyikénél káresemény következne be, a biztosító teljesíteni fog.
						</p>
						<p>
							Fontos, hogy egy hitelügylet kapcsán legfeljebb két személyre köthető biztosítás. A
							szerepkör is lényeges, kizárólag adós és adóstárs kerülhet be a biztosításba.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Lehet kedvezményezettet megadni a biztosításhoz?">
						<p>Igen, természetesen erre van lehetőség.</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Hogyan fizeti ki a biztosító egy káreseménynél a biztosítási összeget?">
						<p>
							A normál hitelfedezeti biztosításoktól eltérően a Bankmonitor Biztonság Csoportos
							Személybiztosítás esetében minden esetben a biztosított/kedvezményezett kapja meg a
							biztosítási összeget. A döntésétől függően ebből az összegből kifizetheti a fennálló
							tartozást, vagy fizetheti tovább folyamatosan a törlesztőrészleteket.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Megköthető otthonról, online is a hitelfedezeti biztosítás?">
						<p>Számos biztosítás megköthető otthonról, online is.</p>
						<p>
							Ilyen a Bankmonitor Biztonság Biztosítás is, melynél a szerződést kizárólag online, a
							Bankmonitor Ügyfélportálon keresztül lehet aláírni.
						</p>
					</LandingAccordion>
				</Accordion>
				<Accordion>
					<LandingAccordion title="Mely bank hiteleihez lehet megkötni a biztosítást?">
						<p>
							A Bankmonitor Biztonság Biztosítás egy bankfüggetlen szolgáltatás. Gyakorlatilag bármely
							pénzintézet hiteléhez meg lehet kötni a konstrukciót.
						</p>
						<p>A teljesség igénye nélkül</p>
						<ul>
							<li>a CIB Bank személyi kölcsönéhez,</li>
							<li>a CIB Bank lakáshiteléhez,</li>
							<li>a CIB Bank Babaváró hiteléhez,</li>
							<li>az ERSTE Bank személyi kölcsönéhez,</li>
							<li>az ERSTE Bank lakáshiteléhez,</li>
							<li>az ERSTE Bank Babaváró hiteléhez,</li>
							<li>a K&H Bank személyi kölcsönéhez,</li>
							<li>a K&H Bank lakáshiteléhez,</li>
							<li>a K&H Bank Babaváró hiteléhez,</li>
							<li>az MBH Bank* személyi kölcsönéhez,</li>
							<li>az MBH Bank* lakáshiteléhez,</li>
							<li>az MBH Bank* Babaváró hiteléhez,</li>
							<li>az OTP személyi kölcsönéhez,</li>
							<li>az OTP lakáshiteléhez,</li>
							<li>az OTP Babaváró hiteléhez,</li>
							<li>a Raiffeisen Bank személyi kölcsönéhez,</li>
							<li>a Raiffeisen Bank lakáshiteléhez,</li>
							<li>a Raiffeisen Bank Babaváró hiteléhez,</li>
							<li>az UniCredit Bank személyi kölcsönéhez,</li>
							<li>az UniCredit Bank lakáshiteléhez,</li>
							<li>és az UniCredit Bank Babaváró hiteléhez</li>
						</ul>
						<p>is megköthető a konstrukció.</p>
						<small>
							* Az MBH Bank a Budapest Bank, az MKB Bank és a Takarékbank fúziójával jött létre. A
							biztosítás abban az esetben is megköthető, ha még a korábban önálló pénzintézetként létező
							három bank valamelyikénél igényelted a kölcsönt.
						</small>
					</LandingAccordion>
				</Accordion>
			</>
		);
	}

	private renderHeaderSlider(): ReactNode {
		return (
			<div className="custom-slider pb-3 px-2">
				{PREMIUM_PRODUCTS.map((prod, prodIndex) => (
					<Card
						className={[prod.customClass, `d-inline-block slider-item bg-white mx-2 mt-1`]
							.filter(Boolean)
							.join(" ")}
						key={prodIndex}
					>
						{prod.customClass.includes("highlighted") && (
							<Card.Header className="bg-success text-uppercase">legjobb ajánlat</Card.Header>
						)}
						<Card.Body className="pt-3 px-2">
							<div className="font-weight-bold">{prod.title}</div>
							<Badge variant="success" className="mt-2 mb-4">
								{prod.badgeText}
							</Badge>
							{prod.questions.map((question, questionIndex) => (
								<div key={questionIndex}>
									<strong className="d-block pb-1 small font-weight-bold">{question.question}</strong>
									<List
										itemStyle={question.variant === "danger" ? "xmark" : "tick"}
										variant={question.variant}
										size="sm"
									>
										{question.answer}
									</List>
								</div>
							))}
						</Card.Body>
						<div className="btn-box px-2">{prod.button}</div>
					</Card>
				))}
			</div>
		);
	}

	private renderVideos(): ReactNode {
		return (
			<LandingContainer as="aside">
				<div className="headline">
					<h2 className="h6 text-uppercase">Kapcsolódó videók</h2>
				</div>
				<Row className="justify-content-center">
					<Col md={6}>
						<YoutubeVideo
							title="Hitelfedezeti biztosítás - Ismerd meg a Bankmonitor Biztonság előnyeit"
							videoId="pGwM7hrpV1Q"
							description="Magyarország egyik legnagyobb életbiztosítója az NN új csoportos személybiztosítási termékkel jelent meg a hitelfedezeti célú konstrukciók piacán. A biztosítás csak a Bankmonitor kínálatában található meg, amely jó alternatívát jelenthet azok számára, akik bankfüggetlen védelmet keresnek hiteleik fedezeteként. Nézzük meg részletesen mit tud ez a termék és miben különbözik a többitől!"
							uploadDate="2022-12-06"
						/>
					</Col>
				</Row>
			</LandingContainer>
		);
	}
}
